// 공유 카드 뒤 방사형 ray burst (디자인 핸드오프 bwek-types.jsx). 팝 컬러, 저투명.
interface Props {
  count?: number;
  r1?: number;
  r2?: number;
  color?: string;
  sw?: number;
  opacity?: number;
  seed?: number;
  size?: number; // viewBox 한 변(중심 기준 ±size/2)
}

export default function RayBurst({
  count = 22,
  r1 = 78,
  r2 = 150,
  color = "#fff",
  sw = 1.2,
  opacity = 0.5,
  seed = 1,
  size = 360,
}: Props) {
  const half = size / 2;
  let s = seed;
  const rnd = () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
  const rays = [];
  for (let i = 0; i < count; i++) {
    const a = (i / count) * Math.PI * 2;
    const rr = r2 * (0.78 + rnd() * 0.34);
    const ri = r1 * (0.92 + rnd() * 0.12);
    rays.push(
      <line
        key={i}
        x1={half + Math.cos(a) * ri}
        y1={half + Math.sin(a) * ri}
        x2={half + Math.cos(a) * rr}
        y2={half + Math.sin(a) * rr}
        stroke={color}
        strokeWidth={sw}
        strokeLinecap="round"
      />,
    );
  }
  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      width="100%"
      height="100%"
      style={{ position: "absolute", inset: 0, pointerEvents: "none" }}
      aria-hidden
    >
      <g opacity={opacity}>{rays}</g>
    </svg>
  );
}
